import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { USER_ROLE_VIEWER } from '../../constants/video';

import { gqlRequest } from '../../helpers/request';
import { revokeShareAction } from '../slices/teamShare';

const queryGQL = `
  mutation hostedWatchRevokeShare(
    $videoId: String,
    $params: HostedWatchRevokeShareInput,
  ) {
    hostedWatchRevokeShare(
      videoId: $videoId,
      params: $params,
    )
  }
`;

export default (action$) =>
  action$.pipe(
    ofType(revokeShareAction.type),
    mergeMap(({ payload }) => {
      const { videoId, userId } = payload;

      return gqlRequest({
        query: queryGQL,
        variables: {
          videoId,
          params: {
            users: [
              {
                id: userId,
                role: USER_ROLE_VIEWER,
              },
            ],
          },
        },
      }).pipe(mergeMap(() => EMPTY));
    }),
  );
